import { type } from '@/utils/type'

//////////////////////////////////////////////////////////////////
// USER
/////////////////////////////////////////////////////////////////
export const ADM_USER_SUCCESS =  type('ADM_USER_SUCCESS')
export const ADM_USER_ERROR =  type('ADM_USER_ERROR')

export const ADM_USER_DETAIL_SUCCESS =  type('ADM_USER_DETAIL_SUCCESS')
export const ADM_USER_DETAIL_ERROR =  type('ADM_USER_DETAIL_ERROR')

export const ADM_USER_SAVE_SUCCESS =  type('ADM_USER_SAVE_SUCCESS')
export const ADM_USER_SAVE_ERROR =  type('ADM_USER_SAVE_ERROR')

export const ADM_USER_SAVE_MEMBER_SUCCESS =  type('ADM_USER_SAVE_MEMBER_SUCCESS')
export const ADM_USER_SAVE_MEMBER_ERROR =  type('ADM_USER_SAVE_MEMBER_ERROR')


export const ADM_USER_DELETE_SUCCESS =  type('ADM_USER_DELETE_SUCCESS')
export const ADM_USER_DELETE_ERROR =  type('ADM_USER_DELETE_ERROR')


//////////////////////////////////////////////////////////////////
// MAIL_TEMPLATE
/////////////////////////////////////////////////////////////////
export const ADM_MAIL_TEMPLATE_SUCCESS =  type('ADM_MAIL_TEMPLATE_SUCCESS')
export const ADM_MAIL_TEMPLATE_ERROR =  type('ADM_MAIL_TEMPLATE_ERROR')

export const ADM_MAIL_TEMPLATE_DETAIL_SUCCESS =  type('ADM_MAIL_TEMPLATE_DETAIL_SUCCESS')
export const ADM_MAIL_TEMPLATE_DETAIL_ERROR =  type('ADM_MAIL_TEMPLATE_DETAIL_ERROR')

export const ADM_MAIL_TEMPLATE_SAVE_SUCCESS =  type('ADM_MAIL_TEMPLATE_SAVE_SUCCESS')
export const ADM_MAIL_TEMPLATE_SAVE_ERROR =  type('ADM_MAIL_TEMPLATE_SAVE_ERROR')

export const ADM_MAIL_TEMPLATE_DELETE_SUCCESS =  type('ADM_MAIL_TEMPLATE_DELETE_SUCCESS')
export const ADM_MAIL_TEMPLATE_DELETE_ERROR =  type('ADM_MAIL_TEMPLATE_DELETE_ERROR')

//////////////////////////////////////////////////////////////////
// MAIL_SKIN
/////////////////////////////////////////////////////////////////
export const ADM_MAIL_SKIN_SUCCESS =  type('ADM_MAIL_SKIN_SUCCESS')
export const ADM_MAIL_SKIN_ERROR =  type('ADM_MAIL_SKIN_ERROR')

export const ADM_MAIL_SKIN_DETAIL_SUCCESS =  type('ADM_MAIL_SKIN_DETAIL_SUCCESS')
export const ADM_MAIL_SKIN_DETAIL_ERROR =  type('ADM_MAIL_SKIN_DETAIL_ERROR')

export const ADM_MAIL_SKIN_SAVE_SUCCESS =  type('ADM_MAIL_SKIN_SAVE_SUCCESS')
export const ADM_MAIL_SKIN_SAVE_ERROR =  type('ADM_MAIL_SKIN_SAVE_ERROR')

export const ADM_MAIL_SKIN_DELETE_SUCCESS =  type('ADM_MAIL_SKIN_DELETE_SUCCESS')
export const ADM_MAIL_SKIN_DELETE_ERROR =  type('ADM_MAIL_SKIN_DELETE_ERROR')

//////////////////////////////////////////////////////////////////
// PISCINE
/////////////////////////////////////////////////////////////////
export const ADM_PISCINE_SUCCESS =  type('ADM_PISCINE_SUCCESS')
export const ADM_PISCINE_ERROR =  type('ADM_PISCINE_ERROR')

export const ADM_PISCINE_DETAIL_SUCCESS =  type('ADM_PISCINE_DETAIL_SUCCESS')
export const ADM_PISCINE_DETAIL_ERROR =  type('ADM_PISCINE_DETAIL_ERROR')

export const ADM_PISCINE_SAVE_SUCCESS =  type('ADM_PISCINE_SAVE_SUCCESS')
export const ADM_PISCINE_SAVE_ERROR =  type('ADM_PISCINE_SAVE_ERROR')

export const ADM_PISCINE_DELETE_SUCCESS =  type('ADM_PISCINE_DELETE_SUCCESS')
export const ADM_PISCINE_DELETE_ERROR =  type('ADM_PISCINE_DELETE_ERROR')

//////////////////////////////////////////////////////////////////
// ACTIVITY
/////////////////////////////////////////////////////////////////
export const ADM_ACTIVITY_SUCCESS =  type('ADM_ACTIVITY_SUCCESS')
export const ADM_ACTIVITY_ERROR =  type('ADM_ACTIVITY_ERROR')

export const ADM_ACTIVITY_DETAIL_SUCCESS =  type('ADM_ACTIVITY_DETAIL_SUCCESS')
export const ADM_ACTIVITY_DETAIL_ERROR =  type('ADM_ACTIVITY_DETAIL_ERROR')

export const ADM_ACTIVITY_SAVE_SUCCESS =  type('ADM_ACTIVITY_SAVE_SUCCESS')
export const ADM_ACTIVITY_SAVE_ERROR =  type('ADM_ACTIVITY_SAVE_ERROR')

export const ADM_ACTIVITY_DELETE_SUCCESS =  type('ADM_ACTIVITY_DELETE_SUCCESS')
export const ADM_ACTIVITY_DELETE_ERROR =  type('ADM_ACTIVITY_DELETE_ERROR')

//////////////////////////////////////////////////////////////////
// FORFAIT
/////////////////////////////////////////////////////////////////
export const ADM_FORFAIT_SUCCESS =  type('ADM_FORFAIT_SUCCESS')
export const ADM_FORFAIT_ERROR =  type('ADM_FORFAIT_ERROR')

export const ADM_FORFAIT_DETAIL_SUCCESS =  type('ADM_FORFAIT_DETAIL_SUCCESS')
export const ADM_FORFAIT_DETAIL_ERROR =  type('ADM_FORFAIT_DETAIL_ERROR')

export const ADM_FORFAIT_SAVE_SUCCESS =  type('ADM_FORFAIT_SAVE_SUCCESS')
export const ADM_FORFAIT_SAVE_ERROR =  type('ADM_FORFAIT_SAVE_ERROR')

export const ADM_FORFAIT_DELETE_SUCCESS =  type('ADM_FORFAIT_DELETE_SUCCESS')
export const ADM_FORFAIT_DELETE_ERROR =  type('ADM_FORFAIT_DELETE_ERROR')

//////////////////////////////////////////////////////////////////
// MNS
/////////////////////////////////////////////////////////////////
export const ADM_MNS_SUCCESS =  type('ADM_MNS_SUCCESS')
export const ADM_MNS_ERROR =  type('ADM_MNS_ERROR')

export const ADM_MNS_DETAIL_SUCCESS =  type('ADM_MNS_DETAIL_SUCCESS')
export const ADM_MNS_DETAIL_ERROR =  type('ADM_MNS_DETAIL_ERROR')

export const ADM_MNS_SAVE_SUCCESS =  type('ADM_MNS_SAVE_SUCCESS')
export const ADM_MNS_SAVE_ERROR =  type('ADM_MNS_SAVE_ERROR')

export const ADM_MNS_DELETE_SUCCESS =  type('ADM_MNS_DELETE_SUCCESS')
export const ADM_MNS_DELETE_ERROR =  type('ADM_MNS_DELETE_ERROR')

//////////////////////////////////////////////////////////////////
// CONTACT
/////////////////////////////////////////////////////////////////
export const ADM_CONTACT_SUCCESS =  type('ADM_CONTACT_SUCCESS')
export const ADM_CONTACT_ERROR =  type('ADM_CONTACT_ERROR')

export const ADM_CONTACT_DETAIL_SUCCESS =  type('ADM_CONTACT_DETAIL_SUCCESS')
export const ADM_CONTACT_DETAIL_ERROR =  type('ADM_CONTACT_DETAIL_ERROR')

export const ADM_CONTACT_MIN_DATE_REQUEST =  type('ADM_CONTACT_MIN_DATE_REQUEST')
export const ADM_CONTACT_MIN_DATE_SUCCESS =  type('ADM_CONTACT_MIN_DATE_SUCCESS')
export const ADM_CONTACT_MIN_DATE_ERROR =  type('ADM_CONTACT_MIN_DATE_ERROR')

export const ADM_CONTACT_SAVE_SUCCESS =  type('ADM_CONTACT_SAVE_SUCCESS')
export const ADM_CONTACT_SAVE_ERROR =  type('ADM_CONTACT_SAVE_ERROR')

export const ADM_CONTACT_DELETE_SUCCESS =  type('ADM_CONTACT_DELETE_SUCCESS')
export const ADM_CONTACT_DELETE_ERROR =  type('ADM_CONTACT_DELETE_ERROR')

export const ADM_CONTACT_ACTION_ON_SELECTION_SUCCESS =  type('ADM_CONTACT_ACTION_ON_SELECTION_SUCCESS')
export const ADM_CONTACT_ACTION_ON_SELECTION_ERROR =  type('ADM_CONTACT_ACTION_ON_SELECTION_ERROR')

//////////////////////////////////////////////////////////////////
// NEWSLETTER
/////////////////////////////////////////////////////////////////
export const ADM_NEWSLETTER_SUCCESS =  type('ADM_NEWSLETTER_SUCCESS')
export const ADM_NEWSLETTER_ERROR =  type('ADM_NEWSLETTER_ERROR')

export const ADM_NEWSLETTER_DETAIL_SUCCESS =  type('ADM_NEWSLETTER_DETAIL_SUCCESS')
export const ADM_NEWSLETTER_DETAIL_ERROR =  type('ADM_NEWSLETTER_DETAIL_ERROR')

export const ADM_NEWSLETTER_SAVE_SUCCESS =  type('ADM_NEWSLETTER_SAVE_SUCCESS')
export const ADM_NEWSLETTER_SAVE_ERROR =  type('ADM_NEWSLETTER_SAVE_ERROR')

export const ADM_NEWSLETTER_DELETE_SUCCESS =  type('ADM_NEWSLETTER_DELETE_SUCCESS')
export const ADM_NEWSLETTER_DELETE_ERROR =  type('ADM_NEWSLETTER_DELETE_ERROR')

export const ADM_NEWSLETTER_VALID_SUCCESS =  type('ADM_NEWSLETTER_VALID_SUCCESS')
export const ADM_NEWSLETTER_VALID_ERROR =  type('ADM_NEWSLETTER_VALID_ERROR')

export const ADM_NEWSLETTER_ACTION_ON_SELECTION_SUCCESS =  type('ADM_NEWSLETTER_ACTION_ON_SELECTION_SUCCESS')
export const ADM_NEWSLETTER_ACTION_ON_SELECTION_ERROR =  type('ADM_NEWSLETTER_ACTION_ON_SELECTION_ERROR')

//////////////////////////////////////////////////////////////////
// COURS
/////////////////////////////////////////////////////////////////
export const ADM_COURS_SUCCESS =  type('ADM_COURS_SUCCESS')
export const ADM_COURS_SUCCESS_DIC =  type('ADM_COURS_SUCCESS_DIC')
export const ADM_COURS_ERROR =  type('ADM_COURS_ERROR')

export const ADM_COURS_DETAIL_SUCCESS =  type('ADM_COURS_DETAIL_SUCCESS')
export const ADM_COURS_DETAIL_ERROR =  type('ADM_COURS_DETAIL_ERROR')

export const ADM_COURS_SAVE_SUCCESS =  type('ADM_COURS_SAVE_SUCCESS')
export const ADM_COURS_SAVE_SUCCESS_DIC =  type('ADM_COURS_SAVE_SUCCESS_DIC')
export const ADM_COURS_CREATE_RANGE_SUCCESS =  type('ADM_COURS_CREATE_RANGE_SUCCESS')
export const ADM_COURS_SAVE_ERROR =  type('ADM_COURS_SAVE_ERROR')

export const ADM_COURS_DELETE_SUCCESS =  type('ADM_COURS_DELETE_SUCCESS')
export const ADM_COURS_DELETE_ERROR =  type('ADM_COURS_DELETE_ERROR')

//////////////////////////////////////////////////////////////////
// COMMANDE
/////////////////////////////////////////////////////////////////
export const ADM_COMMANDE_SUCCESS =  type('ADM_COMMANDE_SUCCESS')
export const ADM_COMMANDE_ERROR =  type('ADM_COMMANDE_ERROR')

export const ADM_COMMANDE_DETAIL_SUCCESS =  type('ADM_COMMANDE_DETAIL_SUCCESS')
export const ADM_COMMANDE_DETAIL_ERROR =  type('ADM_COMMANDE_DETAIL_ERROR')

export const ADM_COMMANDE_MIN_DATE_REQUEST =  type('ADM_COMMANDE_MIN_DATE_REQUEST')
export const ADM_COMMANDE_MIN_DATE_SUCCESS =  type('ADM_COMMANDE_MIN_DATE_SUCCESS')
export const ADM_COMMANDE_MIN_DATE_ERROR =  type('ADM_COMMANDE_MIN_DATE_ERROR')

export const ADM_COMMANDE_SAVE_SUCCESS =  type('ADM_COMMANDE_SAVE_SUCCESS')
export const ADM_COMMANDE_SAVE_ERROR =  type('ADM_COMMANDE_SAVE_ERROR')

export const ADM_COMMANDE_DELETE_SUCCESS =  type('ADM_COMMANDE_DELETE_SUCCESS')
export const ADM_COMMANDE_DELETE_ERROR =  type('ADM_COMMANDE_DELETE_ERROR')


//////////////////////////////////////////////////////////////////
// FAMILY
/////////////////////////////////////////////////////////////////
export const ADM_FAMILY_SUCCESS =  type('ADM_FAMILY_SUCCESS')
export const ADM_FAMILY_ERROR =  type('ADM_FAMILY_ERROR')

export const ADM_FAMILY_DETAIL_SUCCESS =  type('ADM_FAMILY_DETAIL_SUCCESS')
export const ADM_FAMILY_DETAIL_ERROR =  type('ADM_FAMILY_DETAIL_ERROR')

export const ADM_FAMILY_SAVE_SUCCESS =  type('ADM_FAMILY_SAVE_SUCCESS')
export const ADM_FAMILY_SAVE_ERROR =  type('ADM_FAMILY_SAVE_ERROR')

export const ADM_FAMILY_DELETE_SUCCESS =  type('ADM_FAMILY_DELETE_SUCCESS')
export const ADM_FAMILY_DELETE_ERROR =  type('ADM_FAMILY_DELETE_ERROR')